import { PORTAL_NO_AUTH_URL } from '@portalCommon/constants';
import { BackendAxiosError } from '@yaotai/common-utils';

export const portalPcUnAuthCb = (error: BackendAxiosError, msg: string) => {
  window.location.href = PORTAL_NO_AUTH_URL;
};
